import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, RouterLink],
  templateUrl: './email-confirmation.component.html',
})
export class EmailConfirmationComponent {
  public resendPage = commonRoutes.prelogin.onboarding.resendConfirmationMail;
}
